import React, { useRef } from "react"
import { DataGrid, Button, Template } from "devextreme-react"
import {
  Editing,
  Column,
  StateStoring,
  ColumnChooser,
  ColumnFixing,
  Pager,
  FilterPanel,
  Grouping,
  HeaderFilter,
  SearchPanel,
  FilterRow,
  Scrolling,
} from "devextreme-react/data-grid"

import { resourcePriorityDataStore } from "../../shared/ClientStores"
import { hasAccessTo } from "../../../authentication"

const ResourcePriorities = () => {
  const resourcePriorityGrid = useRef(null)

  const refreshResourcePriorityGridClickHandler = () => {
    resourcePriorityGrid.current.instance.refresh(true)
  }

  return (
    <>
      <DataGrid
        columnAutoWidth={true}
        columnResizingMode="widget"
        dataSource={resourcePriorityDataStore}
        hoverStateEnabled={true}
        ref={resourcePriorityGrid}
        rowAlternationEnabled={true}
        showBorders={true}
        visible={hasAccessTo("resource.priority.r")}
        onToolbarPreparing={e => {
          e.toolbarOptions.items.unshift({
            location: "before",
            template: "refreshGrid",
          })
        }}
      >
        <Column
          allowEditing={false}
          defaultVisible={false}
          dataField="id"
          dataType="number"
        />
        <Column dataField="title" dataType="string" />
        <Column dataField="value" dataType="string" />

        <ColumnChooser
          allowSearch={true}
          enabled={true}
          height="400"
          mode="select"
        />
        <ColumnFixing enabled={true} />
        <Editing
          mode="form"
          useIcons={true}
          allowAdding={hasAccessTo("resource.priority.c")}
          allowDeleting={hasAccessTo("resource.priority.d")}
          allowUpdating={hasAccessTo("resource.priority.u")}
        />
        <FilterPanel visible={true} />
        <FilterRow visible={true} />
        <Grouping contextMenuEnabled={true} />
        <HeaderFilter visible={true} />
        <Pager
          visible={true}
          allowedPageSizes={[10, 20, 50, 100]}
          showPageSizeSelector={true}
          showNavigationButtons={true}
          showInfo={true}
        />
        <Scrolling showScrollbar="always" />
        <SearchPanel visible={true} />
        <StateStoring
          enabled={true}
          type="localStorage"
          storageKey="profile-schedule-resource-priorities"
        />
        <Template name="refreshGrid">
          <Button
            icon="refresh"
            onClick={refreshResourcePriorityGridClickHandler}
          />
        </Template>
      </DataGrid>
    </>
  )
}

export { ResourcePriorities }
export default ResourcePriorities
